import { useAuth, normalizeUserType } from '@/core/auth';
import HomePlaceholder from '../HomePlaceholder';
import TowProviderHome from './TowProviderHome';
import AdministratorHome from './AdministratorHome';
import AdjusterHome from './AdjusterHome';
import CustomerHome from './CustomerHome';
import DriverHome from './DriverHome';
import ResolveRole from './ResolveRole';

/**
 * Dispatches to the appropriate role-specific home dashboard.
 *
 * A token that has not settled on a role yet (singleMenu === false &&
 * secondToken === false) goes through ResolveRole, which picks one and comes
 * straight back. That used to be a screen asking the user which of their roles
 * they wanted, on every sign-in; roles are one per account now, so the question
 * has one answer and is no longer worth asking.
 *
 * HomePlaceholder is kept as the catch-all for unknown/legacy userTypes
 * (e.g. the EXTERNALAPI enum value) — better to fail-soft than crash.
 */
export default function HomeRouter() {
  const { currentUser } = useAuth();

  // The token carries no menu until a role is settled, so this has to finish
  // before anything below can dispatch.
  if (currentUser?.singleMenu === false && currentUser.secondToken === false) {
    return <ResolveRole />;
  }

  // Normalize to the all-caps role enum used app-wide. The .NET backend can
  // emit either "Administrator" (PascalCase, Angular-era) or "ADMIN"
  // (all-caps, current). normalizeUserType handles both.
  const role = normalizeUserType(currentUser?.userType ?? '');

  if (role === 'TOWPROVIDER') return <TowProviderHome />;
  if (role === 'ADMIN')        return <AdministratorHome />;
  if (role === 'ADJUSTER')     return <AdjusterHome />;
  if (role === 'CUSTOMER')     return <CustomerHome />;
  if (role === 'DRIVER')       return <DriverHome />;

  return <HomePlaceholder />;
}
